import React from "react";
import { useAppSelector } from "../../hooks/useAppSelector";
import { Roles } from "../../types/roles";
import { Navigate } from "react-router-dom";

const RepositoryIndexRedirect = () => {
  const roles = useAppSelector((state) => state.user.user?.roles) || [];

  const hasKrookie = roles.includes(Roles.KrookieJournal);
  const hasReports = roles.includes(Roles.ReportsJournal);
  const hasUtilities =
    roles.includes(Roles.Contractor) ||
    roles.includes(Roles.DepartmentSpecialist);

  const availableJournalsCount = [hasKrookie, hasReports, hasUtilities].filter(
    Boolean,
  ).length;

  if (availableJournalsCount === 1) {
    if (hasKrookie) return <Navigate to="krookie" replace />;
    if (hasReports) return <Navigate to="reports" replace />;
    if (hasUtilities) return <Navigate to="utilities" replace />;
  }

  return null;
};

export default RepositoryIndexRedirect;
